import React, { useEffect } from "react";
import "../Term/terms.scss";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";

const Cookies = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <main className="mz-legal">
        <div className="mz-legal__header">
          <p className="mz-legal__kicker">LEGAL</p>
          <h1 className="mz-legal__title">Cookie Policy</h1>
        </div>
        <div className="mz-legal__body">
          <div className="mz-legal__section">
            <p>
              We recognize the importance of your privacy. In this cookie policy (“Cookie Policy”), we aim to inform you about the use of cookies on our Website (the “Services” as further detailed in the privacy policy).
            </p>
            <p>
              We use cookies on our Services for a variety of reasons which you can learn about below. We want our Services to be informative, personal, and as user friendly as possible and cookies help us to achieve that goal.
            </p>
          </div>

          <div className="mz-legal__section">
            <h2>What are Cookies?</h2>
            <p>
              A cookie is a small piece of text sent to your browser by our Services. It helps the Services to remember information about your visit, your actions and preferences such as login, language, font size and other display preferences over a period of time, so you don’t have to keep re-entering them whenever you come back to the Services or browse from one page to another. Placing cookies can make your next visit easier and the Services more useful to you.
            </p>
            <p>
              We use several categories of cookies and each performs different functions. You can learn more about cookies and their functions generally by visiting an information website like{" "}
              <a
                href="https://www.allaboutcookies.org/"
                target="_blank"
                rel="noreferrer"
              >
                https://www.allaboutcookies.org/
              </a>
              .
            </p>
          </div>

          <div className="mz-legal__section">
            <h2>The Cookies We Use:</h2>
            <p>
              <strong>Strictly Necessary/Technical Cookies:</strong> Strictly necessary cookies are essential in order to enable you to navigate the Services and use certain features. Because these cookies are strictly necessary we do not need to ask for your consent to use them. Without these strictly necessary cookies, the Services cannot be operated and provided to you. These cookies are necessary to allow us to operate our Services so you may access it as you have requested. These Cookies, for example, let us recognize that you have created an account and have logged into that account to access website or application content. They also include cookies that enable us to remember your previous actions within the same browsing session and secure our Services. These cookies also include cookies which are placed to make your interactions with our Services more secure. We use security cookies to authenticate users, prevent fraudulent use of login credentials, and protect user data from unauthorized parties.
            </p>
            <p>
              <strong>Analytical/Performance Cookies:</strong> These cookies are used by us or third party service providers to analyze how the Services are used and their performance. For example, these cookies track which pages are most frequently visited, and from which locations our visitors come from.
            </p>
            <p>
              <strong>Functionality Cookies:</strong> We may use cookies that allow us to offer you enhanced functionality when accessing or using our Services. Our functionality cookies are used to remember choices you make such as language preference, country location, or other online settings as well as identify you when you sign in to our Application or keep track of your specified preferences and interests. Functionality cookies enable us to improve and enhance the presentation of content on our Services.
            </p>
            <p>
              <strong>Third Party Advertising Cookies:</strong> These cookies collect information about your activities on the Services and other websites to provide you targeted advertising. We may also allow our third party service providers to use cookies on the Services for the same purposes identified above, including collecting information about your online activities over time and across different websites.
            </p>
          </div>

          <div className="mz-legal__section">
            <h2>Disabling Cookies</h2>
            <p>
              There are a number of ways for you to manage cookies and other tracking technologies. Through our cookie pop-up bar or your browser settings, you can accept or decline cookies that we place. You should be aware that you may not be able to use all our interactive features if you choose to decline the use of cookies. Most web browsers allow some control of most cookies through the browser settings. To find out how to manage cookies on popular browsers:
            </p>
            <p>
              <a
                href="https://support.google.com/accounts/answer/61416?co=GENIE.Platform%3DDesktop&hl=en"
                target="_blank"
                rel="noreferrer"
              >
                Google Chrome
              </a>
            </p>
            <p>
              <a
                href="https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences"
                target="_blank"
                rel="noreferrer"
              >
                Mozilla Firefox
              </a>
            </p>
            <p>
              <a
                href="https://support.microsoft.com/en-gb/help/17442/windows-internet-explorer-delete-manage-cookies"
                target="_blank"
                rel="noreferrer"
              >
                Microsoft Internet Explorer
              </a>
            </p>
            <p>
              <a
                href="https://www.opera.com/help/tutorials/security/privacy/"
                target="_blank"
                rel="noreferrer"
              >
                Opera
              </a>
            </p>
            <p>
              <a href="https://support.apple.com/en-gb/safari" target="_blank" rel="noreferrer">
                Apple Safari
              </a>
            </p>
          </div>

          <div className="mz-legal__section">
            <h2>Changes and Updates</h2>
            <p>
              We may update this Cookie Policy from time to time. We encourage you to periodically review this Cookie Policy to stay informed about our use of cookies, the information we collect via cookies, and any updates in relation thereto.
            </p>
            <p>We will post any changes to this Cookie Policy on our Services.</p>
          </div>

          <div className="mz-legal__section">
            <h2>Contact Us</h2>
            <p>If you have questions about this Cookie Policy, please contact us.</p>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default Cookies;
